import { environment } from '../../../environments/environment';

/**
 * Construye la URL completa basándose en la ruta proporcionada y el entorno.
 * @param currentRoute Ruta actual del router
 * @param excludeParams Parámetros a excluir de la URL (opcional)
 * @returns URL completa de la pantalla
 */
export function buildFullUrl(currentRoute: string, excludeParams?: string[]): string {
  // URLs correctas para motos según ambiente
  const baseUrl = environment.production
    ? 'https://ecomm.sura.co'
    : 'https://motoslab.ecomm.sura.co';

  // Si no hay parámetros a excluir, retornar la URL completa con base.
  if (!excludeParams || excludeParams.length === 0) {
    return `${baseUrl}${currentRoute}`;
  }

  // Separar la ruta de los query params
  const [path, queryString] = currentRoute.split('?');

  // Si no hay query string, retornar la URL sin cambios.
  if (!queryString) {
    return `${baseUrl}${path}`;
  }

  // Parsear los query params
  const urlSearchParams = new URLSearchParams(queryString);

  // Eliminar los parámetros especificados
  excludeParams.forEach(param => {
    urlSearchParams.delete(param);
  });

  // Reconstruir la URL
  const cleanQueryString = urlSearchParams.toString();
  const finalRoute = cleanQueryString ? `${path}?${cleanQueryString}` : path;

  return `${baseUrl}${finalRoute}`;
}
